/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: table,テーブル,currency,通貨
 * note:
 *  - テーブルカラムの指摘したセルの表示を通貨形式で表示させるdirective
 *  -
 * sample:
 *  -
 * :ZNOTE:
 */


const setCurrency = (e) => {
  if (e.innerText && isNumeric(e.innerText)) {
    const n = parseInt(e.innerText.replace(',', ''));
    if (n) {
      e.innerText = n.toLocaleString();
      if (n < 0) {
        e.style.color = 'red';
      }
    }
  }
};

const isNumeric = (val) => {
  const v = val.replace(',', '');
  return /^-?\d+$/.test(v);
};


const zCurrency = {
  updated(el: any, binding: any) {
    if (typeof binding.value !== 'undefined' && !binding.value) return;

    const trList = el.querySelectorAll('tr.z-table-body');
    trList.forEach((tr) => {
      const tdList = tr.querySelectorAll('td');
      binding.value.forEach((i) => {
        setCurrency(tdList[i]);
      });
    });
  },
};

export default zCurrency;
